/** @format */
import React from 'react';

// A local status, never a backdrop. Short requests stay completely silent.
export default function Progress({trim = 'loading', label = 'Načítání vozidel…', delay = 300, onRetry}) {
  const [visible, setVisible] = React.useState(false);
  React.useEffect(() => {
    if (trim !== 'loading') {
      setVisible(false);
      return;
    }
    const timer = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(timer);
  }, [trim, delay]);

  if (trim === 'error') {
    return (
      <section className="app-load-status app-load-status--error" role="alert">
        <div>
          <strong>Vozidla se nepodařilo načíst.</strong>
          <p>Zkontrolujte připojení a zkuste to znovu.</p>
        </div>
        <div className="app-load-status__actions">
          <button type="button" onClick={onRetry}>Zkusit znovu</button>
          <a href="/#/login">Přihlásit se</a>
        </div>
      </section>
    );
  }
  if (trim !== 'loading' || !visible) return null;
  return (
    <div className="app-load-status" role="status" aria-live="polite" aria-atomic="true">
      <span className="app-load-status__indicator" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
